import { admins } from 'types';
import React from 'react';
import { TMaterialTableColumns } from 'components/table/index.types';
import { Checkbox } from '@material-ui/core';

// do not change the item orders
const permissions = [
    'adminsView',
    'adminsEdit',
    'userView',
    'userPinEdit',
    'userSuspendEdit',
    'userEKYCEdit',
    'userAccountEdit',
    'transactionView',
    'transactionEdit',
    'pendingTaskView',
    'pendingTaskEdit',
    'withdrawalView',
    'withdrawalEdit',
    'adminActivityLogView',
    'userActivityLogView',
    'screeningView',
];

const convertedKeysToReadableString = (key: string) => {
    const convertedKey = key.replace(/([a-z])([A-Z])/g, '$1 $2'); // Add space before capital letter
    return convertedKey.charAt(0).toUpperCase() + convertedKey.slice(1); // Capitalize first letter
};

const convertToColumnTemplate = (permissions: string[]) => {
    return permissions.map((permission) => ({
        // key: permission,
        title: convertedKeysToReadableString(permission),
        render: (props: any) => (
            <>
                <Checkbox
                    color="primary"
                    checked={props.rowData.permissions[permission]}
                />
            </>
        ),
    }));
};

const adminPermissionRoleColumns =
    (): TMaterialTableColumns<admins.TAdminPermissionRole> => [
        {
            key: 'roleName',
            title: 'Permission Role',
        },
        ...convertToColumnTemplate(permissions),
    ];

export default adminPermissionRoleColumns;
